import { DeleteOutlined } from '@ant-design/icons';
import * as Antd from 'antd';

import { getActionControlStyleVars } from './actionControlStyles';

type ActionDeleteButtonProps = {
    onClick: React.MouseEventHandler<HTMLElement>;
    disabled?: boolean;
    tooltipTitle?: string;
};

export const ActionDeleteButton = ({ onClick, disabled, tooltipTitle = 'Видалити' }: ActionDeleteButtonProps) => {
    const { token } = Antd.theme.useToken();
    const styleVars = getActionControlStyleVars(token, {
        variant: 'text',
        tone: 'danger',
        bordered: true,
        iconOnly: true,
        disabled,
    });

    return (
        <Antd.Tooltip title={tooltipTitle}>
            <Antd.Button
                type="text"
                danger
                className="app-action-control app-action-control--icon"
                style={styleVars}
                icon={<DeleteOutlined style={{ fontSize: 16 }} />}
                onClick={onClick}
                disabled={disabled}
            />
        </Antd.Tooltip>
    );
};
